import { render, staticRenderFns } from "./ShutDown.vue?vue&type=template&id=8fbb1684"
import script from "./ShutDown.vue?vue&type=script&lang=js"
export * from "./ShutDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports